import actions from './actions';

const {
  PRODUCT_LIST_BEGIN,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_ERR,
} = actions;

const initialState = {
  data: null,
  loading: true,
  error: null,
};

const userProductListReducer = (state = initialState, action) => {
  const { type,data,err } = action;
  switch (type) {
    case PRODUCT_LIST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case PRODUCT_LIST_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { userProductListReducer};
